function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import ReactSelect from 'react-select-plus';
import classnames from 'classnames';
import noop from 'lodash.noop';
import Close from "./Close";
import Option from "./SelectOption.js";
import SelectArrow from "./SelectArrow";
import SelectMultiValue from "./SelectMultiValue.js";

var Select = function Select(_ref) {
  var _arrowRenderer = _ref.arrowRenderer,
      className = _ref.className,
      inputProps = _ref.inputProps,
      multi = _ref.multi,
      name = _ref.name,
      valueProp = _ref.value,
      valueComponent = _ref.valueComponent,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["arrowRenderer", "className", "inputProps", "multi", "name", "value", "valueComponent", "onChange"]);

  var _useState = useState(valueProp || props.defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    return setValue(valueProp);
  }, [valueProp]);

  var handleChange = function handleChange(newValue) {
    setValue(newValue);
    onChange(newValue);
  };

  var SelectElement = ReactSelect;

  if (props.loadOptions && props.creatable) {
    SelectElement = ReactSelect.AsyncCreatable;
  } else if (props.loadOptions) {
    SelectElement = ReactSelect.Async;
  } else if (props.creatable) {
    SelectElement = ReactSelect.Creatable;
  }

  var classNames = classnames(className, {
    'select-async': props.loadOptions
  });
  var valueComponentRenderer = valueComponent || (multi ? SelectMultiValue : undefined);
  return /*#__PURE__*/React.createElement(SelectElement, _extends({
    arrowRenderer: function arrowRenderer(_ref2) {
      var isOpen = _ref2.isOpen;
      return /*#__PURE__*/React.createElement(SelectArrow, {
        isOpen: isOpen,
        render: _arrowRenderer
      });
    },
    clearRenderer: function clearRenderer() {
      return /*#__PURE__*/React.createElement(Close, {
        tabIndex: -1,
        style: {
          fontSize: '1rem'
        }
      });
    },
    optionComponent: Option,
    inputProps: _objectSpread({
      name: name
    }, inputProps),
    multi: multi,
    onChange: handleChange,
    value: valueProp || value,
    valueComponent: valueComponentRenderer,
    className: classNames,
    name: name
  }, props));
};

Select.displayName = "Select";
Select.propTypes = _objectSpread({
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.any
}, ReactSelect.propTypes);
Select.defaultProps = {
  onChange: noop
};
Select.displayName = 'Select';
export default Select;